import http from "api/https";

export const signFiles = (
  ids: number[],
  applicationId: number,
  pin: string,
  code: string,
  pinOrganization?: string
): Promise<any> => {
  return http.post(`/api/v1/appFile/SignDocuments`, {
    ids,
    applicationId,
    pin,
    code,
    ...(pinOrganization ? { pinOrganization } : {}),
  });
};

export const sendCode = (pin: string, pinOrganization?: string): Promise<any> => {
  const query = pinOrganization
    ? `pin=${pin}&pinOrganization=${pinOrganization}`
    : `pin=${pin}`;
  return http.get(`/api/v1/appFile/SendCode?${query}`, {});
};